import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Login from './Admin/pages/Login';
// import { BlogProvider } from './fetchdata/BlogContext';


import Dashboard from './Admin/pages/Dashboard';
import Addblog from './Admin/pages/Blogs/Addblog';
import AddGallery from './Admin/pages/Gallery/addGallery';
import BuildBlogs from './Admin/pages/builder/buildBlogs';
import AdminAllBlogs from './Admin/pages/Blogs/AllBlogs';
import EditAdminBlogs from './Admin/pages/Blogs/EditAdminBlogs';
import AllCategory from './Admin/pages/category/AllCategory';
import EditCategory from './Admin/pages/category/EditCategory';
import AddCategory from './Admin/pages/category/AddCategory';
import AllProduct from './Admin/pages/product/AllProduct';
import EditProduct from './Admin/pages/product/EditProduct';
import AddProduct from './Admin/pages/product/AddProduct';

import AddAttribute from './Admin/pages/attribute/AddAttribute';
import EditAttribute from './Admin/pages/attribute/EditAttribute';
import AllAttribute from './Admin/pages/attribute/AllAttribute';

import AddTag from './Admin/pages/tag/AddTag';
import EditTag from './Admin/pages/tag/EditTag';
import AllTag from './Admin/pages/tag/AllTag';

import MenuBuilder from './Admin/pages/builder/MenuBuilder';
import FooterMenuBuilder from './Admin/pages/builder/FooterMenuBuilder';

import HomeLayout from './Admin/pages/home/HomeLayout';
import AllReview from './Admin/pages/review/AllReview';
import AllOrder from './Admin/pages/order/AllOrder';
import PendingOrder from './Admin/pages/order/PendingOrder';
import CompleteOrder from './Admin/pages/order/CompleteOrder';

import AllUser from './Admin/pages/user/AllUser';
import UserView from './Admin/pages/user/UserView';
import ThemeSetting from './Admin/pages/home/ThemeSetting';

import AllZones from './Admin/pages/zones/AllZones';
import EditZones from './Admin/pages/zones/EditZones';
import AddZones from './Admin/pages/zones/AddZones';

import AllTax from './Admin/pages/tax/AllTax';
import EditTax from './Admin/pages/tax/EditTax';
import AddTax from './Admin/pages/tax/AddTax';

import AllPromo from './Admin/pages/promo/AllPromo';
import EditPromo from './Admin/pages/promo/EditPromo';
import AddPromo from './Admin/pages/promo/AddPromo';
import OrderView from './Admin/pages/order/OrderView';

import AddPage from './Admin/pages/pages/AddPage';
import AllPage from './Admin/pages/pages/AllPage';
import EditPage from './Admin/pages/pages/EditPage';
import AllImages from './Admin/pages/Gallery/AllImages';
import AllEnquire from './Admin/pages/enquire/AllEnquire';

import AddPlanCategory from './Admin/pages/planCategory/AddPlanCategory';
import AllPlanCategory from './Admin/pages/planCategory/AllPlanCategory';
import AddPlan from './Admin/pages/plan/AddPlan';
import AllPlan from './Admin/pages/plan/AllPlan';
import EditPlan from './Admin/pages/plan/EditPlan';
import ProfileEdit from './Admin/pages/user/ProfileEdit';

import Forgot from './Admin/pages/Forgot';

import Admin404 from './Admin/pages/Admin404';

import { Toaster } from "react-hot-toast";
import './Admin/assets/css/volt.css';



import getCookie from './helpers/getCookie';
import getDecryptData from './helpers/getDecryptData';
import getUserData from "./helpers/userAuth";
import { ThemeProvider } from './fetchdata/ThemeContext';
import PlanView from './Admin/pages/plan/PlanView';
import AllEnquireHealth from './Admin/pages/enquire/AllEnquireHealth';
import BuyPlan from './Admin/pages/plan/BuyPlan';
import MyHealthCard from './Admin/pages/healthcard/MyHealthCard';
import AddDepartment from './Admin/pages/department/AddDepartment';
import AllDepartment from './Admin/pages/department/AllDepartment';
import EditDepartment from './Admin/pages/department/EditDepartment';
import AdminLoader from './Admin/pages/AdminLoader';
import AllTransactions from './Admin/pages/transaction/AllTransactions';
import AllHealthCard from './Admin/pages/healthcard/AllHealthCard';
import FullOrderView from './Admin/pages/order/FullOrderView';
import CreateLead from './Admin/pages/order/CreateLead';
import PendingLead from './Admin/pages/order/PendingLead';
import AsignLead from './Admin/pages/order/AsignLead';
import AllReferralOrder from './Admin/pages/order/AllReferralOrder';
import UserAllTransactions from './Admin/pages/transaction/UserAllTransactions';
import SignupUserType from './Admin/pages/user/SignupUserType';
import AllJob from './Admin/pages/job/AllJob';
import MyJob from './Admin/pages/job/MyJob';
import { Toast } from 'bootstrap/dist/js/bootstrap.bundle.min';
import CompleteJob from './Admin/pages/job/CompleteJob';
import UserAllPayments from './Admin/pages/transaction/UserAllPayments';
import AdminAllPaymentsInvoice from './Admin/pages/payments/AdminAllPaymentsInvoice';
import AdminAllBilling from './Admin/pages/payments/AdminAllBilling';
import CancelOrder from './Admin/pages/order/CancelOrder';
import PendingJob from './Admin/pages/job/PendingJob';
import CancelJob from './Admin/pages/job/CancelJob';
import AllWithdrawal from './Admin/pages/withdrawal/AllWithdrawal';
import AdminAllPaymentsOrderInvoice from './Admin/pages/payments/AdminAllPaymentsOrderInvoice';
import LiveUser from './Admin/pages/user/LiveUser';
import ThemeNotificationSetting from './Admin/pages/home/ThemeNotificationSetting';
import NavbarMenuBuilder from './Admin/pages/builder/NavbarMenuBuilder';

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};


function App() {

  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);
  const [isUsertypeEmp, setisUsertypeEmp] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsUserAuthenticated(isLoginFromLocalStorage);
      const mydata = await getDecryptData();
      if (mydata) {
        const mydatatype = mydata.type;
        const mydatatypeEmp = mydata.empType;
        setisUsertype(mydatatype);
        setisUsertypeEmp(mydatatypeEmp);
      }

      console.log("mydata", mydata, isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [isLoginFromLocalStorage, location.pathname]);

  return (

    <>
      <ThemeProvider>


        <Toaster />

        <Routes>


          <Route
            path="/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Navigate to="/dashboard" />) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || <Login />
            }
          />


          <Route
            path="/forgot"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Forgot />) ||
                  (isUsertype === 0 && <Forgot />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/dashboard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Dashboard />) ||
                  (isUsertype === 0 && <Dashboard />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/addblog"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <Addblog />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-gallery"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddGallery />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/buildBlogs/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <BuildBlogs />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/allblogs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminAllBlogs />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/edit-blog/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditAdminBlogs />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && isUsertypeEmp === 1 && <AddCategory />) ||
                  (isUsertype === 0 && <AddCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && isUsertypeEmp === 1 && <AllCategory />) ||
                  (isUsertype === 0 && <AllCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-order"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  // ((isUsertype === 1 && isUsertypeEmp !== 2) && <AllOrder />) ||
                  (isUsertype === 1 && <AllOrder />) ||
                  (isUsertype === 0 && <AllOrder />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/pending-order"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  // ((isUsertype === 1 && isUsertypeEmp == 2) && <PendingOrder />) ||
                  (isUsertype === 1 && <PendingOrder />) ||
                  (isUsertype === 0 && <PendingOrder />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/complete-order"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  // ((isUsertype === 1 && isUsertypeEmp !== 2) && <CompleteOrder />) ||
                  (isUsertype === 1 && <CompleteOrder />) ||
                  (isUsertype === 0 && <CompleteOrder />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/cancel-order"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  // ((isUsertype === 1 && isUsertypeEmp !== 2) && <CancelOrder />) ||
                  (isUsertype === 1 && <CancelOrder />) ||
                  (isUsertype === 0 && <CancelOrder />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/all-referral-Order"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 3 && <AllReferralOrder />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-transaction"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 1 && <AdminLoader />) ||
                  (isUsertype === 1 && <UserAllTransactions />) ||
                  (isUsertype === 0 && <AllTransactions />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-withdrawal"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 1 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllWithdrawal />) ||
                  (isUsertype === 0 && <AllWithdrawal />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/all-payment"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 1 && <AdminLoader />) ||
                  (isUsertype === 1 && <UserAllPayments />) ||
                  (isUsertype === 0 && <AllTransactions />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/admin/all-payments-invoice/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 1 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminAllPaymentsInvoice />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/admin/all-order-invoice/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 1 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminAllPaymentsOrderInvoice />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/admin/all-payments/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 && isUsertype !== 1 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminAllBilling />))) || <Navigate to="/" />
            }
          />


          <Route path="/pending-lead"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <PendingLead />) ||
                  (isUsertype === 3 && <PendingLead />) ||
                  (isUsertype === 0 && <PendingLead />))) || <Navigate to="/" />
            }
          />
          <Route path="/asign-lead"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <AsignLead />) ||
                  (isUsertype === 3 && <AdminLoader />) ||
                  (isUsertype === 0 && <AsignLead />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/create-lead"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <CreateLead />) ||
                  (isUsertype === 0 && <CreateLead />))) || <Navigate to="/" />
            }
          />



          <Route path="/order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <FullOrderView />) ||
                  (isUsertype === 3 && <FullOrderView />) ||
                  (isUsertype === 0 && <FullOrderView />))) || <Navigate to="/" />
            }
          />




          <Route
            path="/edit-category/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-product"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && isUsertypeEmp === 1 && <AddProduct />) ||
                  (isUsertype === 0 && <AddProduct />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-product"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && isUsertypeEmp === 1 && <AllProduct />) ||
                  (isUsertype === 0 && <AllProduct />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-product/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && isUsertypeEmp === 1 && <EditProduct />) ||
                  (isUsertype === 0 && <EditProduct />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-attribute"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddAttribute />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-attribute"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllAttribute />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-attribute/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditAttribute />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-tag"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddTag />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-tag"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllTag />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-tag/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditTag />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-menu"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <MenuBuilder />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-navbar-menu"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <NavbarMenuBuilder />))) || <Navigate to="/" />
            }
          />



          <Route
            path="/add-footer-menu"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <FooterMenuBuilder />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/home-layout"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <HomeLayout />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-enquire"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllEnquire />))) || <Navigate to="/" />
            }
          />



          <Route
            path="/all-user/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllUser />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/live-users/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <LiveUser />))) || <Navigate to="/" />
            }
          />




          <Route
            path="/user/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <UserView />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/theme-setting"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <ThemeSetting />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/push-notification"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <ThemeNotificationSetting />))) || <Navigate to="/" />
            }
          />




          <Route
            path="/add-zones"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddZones />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-zones"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllZones />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-zones/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditZones />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-taxes"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditZones />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-taxes"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllTax />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-taxes/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditTax />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-promo"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPromo />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-promo"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPromo />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/edit-promo/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPromo />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-page"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPage />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-page"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPage />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-page/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPage />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-images"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllImages />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-plan-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPlanCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-plan-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPlanCategory />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-plan"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPlan />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-plan"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPlan />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-plan/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPlan />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-plan/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPlan />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/profile/edit"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <ProfileEdit />) ||
                  (isUsertype === 3 && <ProfileEdit />) ||
                  (isUsertype === 0 && <ProfileEdit />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-enquire-health"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllEnquireHealth />) ||
                  (isUsertype === 0 && <Dashboard />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/add-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddDepartment />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllDepartment />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-department/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditDepartment />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-transactions"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllTransactions />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-healthcard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllHealthCard />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/reviews"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllReview />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/create-user"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <SignupUserType />))) || <Navigate to="/" />
            }
          />

          {/* <Route
            path="/all-jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllJob />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          />
         
       <Route
            path="/pending-jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <PendingJob />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          />

           <Route
            path="/cancel-jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <CancelJob />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          /> */}

          {/* 
          <Route
            path="/complete-jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <CompleteJob />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          />
 */}



          <Route path="*" element={<Admin404 />} />

        </Routes>
        <ScrollToTop />
      </ThemeProvider>
    </>
  );
}

export default App;
